import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from './locales/en/translation.json'

const resources = {
  en: {
    common: enTranslations
  }
}

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === "development",
});

export default i18next;